
import merge from 'lodash.merge'

const DEFAULT_STATE = {
  home: null,
  list: []
}

export default {
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    home(state) {
      if (state.home === null) return {}
      let homeState = {}
      state.list.forEach(savedState => {
        if (savedState.uid === state.home) homeState = savedState.state
      })
      return homeState
    }
  },
  mutations: {
    add(state, newState) {
      state.list.push({
        uid: (new Date()).valueOf(),
        name: newState.name,
        state: {
          center: newState.state.center
        }
      })
    },
    setHome(state, id) {
      state.home = state.list[id].uid
    },
    setName(state, { id, name }) {
      state.list[id].name = name
    },
    update(state, { id, newState }) {
      state.list[id].state = {
        center: newState.center
      }
    },
    delete(state, id) {
      if (state.home === state.list[id].uid) {
        state.home = null
      }
      state.list.splice(id, 1)
    },
    moveToUp(state, id) {
      const newState = state.list[id]
      state.list.splice(id, 1)
      state.list.unshift(newState)
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE)
    }
  },
  actions: {
    add(context, newState) {
      context.commit('add', merge({}, newState))
    },
    setHome(context, id) {
      context.commit('setHome', id)
      context.commit('moveToUp', id)
    },
    setName(context, { id, name }) {
      context.commit('setName', { id, name })
    },
    update(context, { id, newState }) {
      context.commit('update', {
        id,
        newState: merge({}, newState)
      })
    },
    delete(context, id) {
      context.commit('delete', id)
    },
    moveToUp(context, id) {
      context.commit('moveToUp', id)
    },
    resetStore(context) {
      context.commit('resetStore')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/favorites.js